<!--  Hero Section -->
<section id="hero">
  <app-hero></app-hero>
</section>

<!-- Apps Ecosystem Bridge Section -->
<section id="apps">
  <app-apps></app-apps>
</section>

<!-- Why Choose Us & Testimonials Section -->
<section id="why">
  <app-why></app-why>
</section>

<!-- Features Section -->
<section id="features">
  <app-features></app-features>
</section>

<!-- Working New Section -->
<section id="working">
  <app-working></app-working>
</section>

<!-- Pricing Section -->
<section id="pricing">
  <app-pricing></app-pricing>
</section>